import styled from 'styled-components';
import { BulkActionsBar } from 'ui/bulkActionsBar';
import { IndexTabsList } from 'ui/tabsGroup';
import { spacing } from 'ui/theme';

export const SearchWrapper = styled.div`
  min-width: ${spacing.x16};
`;

export const StyledLockNotification = styled.div`
  flex-grow: 1;
`;

export const StyledTabsList = styled(IndexTabsList)`
  padding-bottom: 0;
  flex-grow: 1;
`;

export const StyledActionsBar = styled(BulkActionsBar)`
  height: auto;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.base};
  column-gap: ${spacing.half};
  margin-bottom: ${spacing.plusQuarter};

  &[data-mode='edit'] {
    row-gap: ${spacing.threeQuarter};
    margin-bottom: 0;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const Filters = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
